export default __webpack_public_path__ + "static/media/alpha+waves.037f1870.mp3";